import type { PublicEvent, VolunteerRole } from "../../shared/types";
import { bucketOf, ROLE_LABELS } from "../../shared/types";
import { capacityFor, formatDate, weekdayOf } from "../lib/hours";

interface Props {
  event: PublicEvent;
  checked: boolean;
  roles: VolunteerRole[];
  onToggle: (id: number) => void;
}

export default function EventCard({ event, checked, roles, onToggle }: Props) {
  const eligible = event.eligibleRoles.length === 0 || roles.some((r) => event.eligibleRoles.includes(r));
  const disabled = !eligible && !checked;

  const bucket = bucketOf(roles);
  const myCap = capacityFor(event, bucket);
  const seed = capacityFor(event, "seed");
  const act = capacityFor(event, "activity");

  // 若勾選這場、你會排在遞補第幾位（尚未勾選時就是現有遞補數 +1）
  const projectedPos = myCap.full ? myCap.waitlist + (checked ? 0 : 1) : 0;

  return (
    <label className={`event${checked ? " on" : ""}${disabled ? " disabled" : ""}`}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={() => onToggle(event.id)} />
      <div className="e-body">
        <div className="e-title">
          {formatDate(event.eventDate)}
          {event.eventDate && `（${weekdayOf(event.eventDate)}）`} · {event.title}
        </div>
        <div className="e-meta">
          {event.location && <span>📍 {event.location}</span>}
          {event.startTime && event.endTime && (
            <span>
              🕘 {event.startTime}–{event.endTime}
            </span>
          )}
          <span className="pill hours">認列 {event.creditHours} 小時</span>
          <span className={`pill${event.category === "charity" ? " charity" : ""}`}>
            {event.category === "charity" ? "星星國公益活動" : "AR伴讀"}
          </span>
          <span>{event.format}</span>
        </div>

        <div className="e-meta" style={{ marginTop: 2 }}>
          <span>
            種子教師名額 {Math.min(seed.confirmed, seed.cap ?? seed.confirmed)}/{seed.cap ?? "∞"}
            {seed.full ? "（額滿）" : ""}
          </span>
          <span>
            活動志工名額 {Math.min(act.confirmed, act.cap ?? act.confirmed)}/{act.cap ?? "∞"}
            {act.full ? "（額滿）" : ""}
          </span>
        </div>

        {event.note && <div className="e-note">※ {event.note}</div>}
        {disabled && <div className="e-note">此場次不適用你目前選擇的志工身分</div>}
        {!disabled && roles.length > 0 && myCap.full && (
          <div className="e-note">
            以「{ROLE_LABELS[bucket === "seed" ? "english_seed" : "activity"]}」身分，此場次名額已滿；
            勾選後將列為<strong>遞補第 {projectedPos} 位</strong>，建議多選其他場次。
          </div>
        )}
      </div>
    </label>
  );
}
